import { ColumnState } from 'ag-grid-community';
import { DateRange } from 'react-day-picker';
import { create } from 'zustand';

import { defaultSAL3010_R01DetailDto, defaultSAL3010_R01HeaderDto, SAL3010_R01DetailDto, SAL3010_R01HeaderDto } from './Dto_SAL3010_R01';

export interface SAL3010_R01Filter {
	
	paymentDateRange: DateRange | undefined	;	//수금기간
	tradeDateRange: DateRange | undefined;		//매출기간
	customCd: string;
	customNm: string;
	compCd: string;
	compNm: string;
	tradeType: string;							//수금구분

}
export interface Store_SAL3010_R01 {
	SAL3010_R01Filter: SAL3010_R01Filter;
	SAL3010_R01PastFilter: SAL3010_R01Filter;
	setSAL3010_R01Filter: (filter: Partial<Store_SAL3010_R01['SAL3010_R01Filter']>) => void;
	setSAL3010_R01PastFilter: (filter: Store_SAL3010_R01['SAL3010_R01PastFilter']) => void;
	
	// ====== 매출 리스트 및 선택/편집 ======
	SAL3010_R01List: SAL3010_R01HeaderDto[];
	setSAL3010_R01List: (dataList: SAL3010_R01HeaderDto[]) => void;

	editSAL3010_R01: SAL3010_R01HeaderDto | null;
	setEditSAL3010_R01: (editSale: SAL3010_R01HeaderDto | null) => void;

	selectedSAL3010_R01: SAL3010_R01HeaderDto | undefined;
	setSelectedSAL3010_R01: (data: SAL3010_R01HeaderDto | undefined) => void;
	initSelectedSAL3010_R01: () => void;

	// ====== 상세(디테일) 행 선택/삭제 관리 ======
	deletedSAL3010_R01DetailList: string[];
	setDeletedSAL3010_R01DetailList: (idList: string[]) => void;
	addDeletedSAL3010_R01DetailList: (idList: string[]) => void;
	removeDeletedSAL3010_R01DetailList: (idList?: string[]) => void;

	// ====== 매출 상세(디테일) 데이터 ======
	SAL3010_R01DetailList: SAL3010_R01DetailDto[];
	setSAL3010_R01DetailList: (data: SAL3010_R01DetailDto[]) => void;
	insertSAL3010_R01DetailList: (data: SAL3010_R01DetailDto[], index?: number) => void;
	removeSAL3010_R01DetailList: (index: number) => void;
	updateSAL3010_R01DetailList: (index: number, data: SAL3010_R01DetailDto) => void;

	// ====== 선택(디테일) 행 선택/삭제 관리 ======
	selectedSAL3010_R01DetailList: string[];
	setSelectedSAL3010_R01DetailList: (idList: string[]) => void;
	addSelectedSAL3010_R01DetailList: (idList: string[]) => void;
	removeSelectedSAL3010_R01DetailList: (idList?: string[]) => void;
	initSelectedSAL3010_R01DetailList: () => void;

	originalSAL3010_R01DetailList: SAL3010_R01DetailDto[];
	setOriginalSAL3010_R01DetailList: (data: SAL3010_R01DetailDto[]) => void;

	// ====== 컬럼 상태(그리드) ======
	columnState: ColumnState[] | null;
	setColumnState: (state: ColumnState[] | null) => void;
	detailColumnState: ColumnState[] | null;
	setDetailColumnState: (state: ColumnState[] | null) => void;

	allCount: number;						setAllCount: (allCount: number) => void;
	detailFetchTrigger: boolean;			setDetailFetchTrigger: (trigger: boolean) => void;
	detailCreateTrigger: boolean;			setDetailCreateTrigger: (trigger: boolean) => void;

	scrollTop: number | null;
	setScrollTop: (top: number | null) => void;
	detailScrollTop: number | null;
	setDetailScrollTop: (top: number | null) => void;
	

	// ====== 초기화 ======
	initData: () => void;

}

export const defaultSAL3010_R01Filter : SAL3010_R01Filter = {
	
	paymentDateRange: {
		from: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
		to: new Date()
	},
	tradeDateRange: {
		from: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
		to: new Date()
	},
	customCd: '',
	customNm: '',
	compCd: '',
	compNm: '',
	tradeType: ''
};

export const noteCreateFlgMap_SAL3010_R01 = [
	{ title: '자수', value: 'IN' },
	{ title: '타수', value: 'OUT' },
]

export const useSAL3010_R01Store = create<Store_SAL3010_R01>((set) => ({
	SAL3010_R01Filter: defaultSAL3010_R01Filter,
	SAL3010_R01PastFilter: defaultSAL3010_R01Filter,
	setSAL3010_R01Filter: (update) => set((state) => ({
		SAL3010_R01Filter: {
			...state.SAL3010_R01Filter,
			...update
		}
	})),
	setSAL3010_R01PastFilter: (filter: Store_SAL3010_R01['SAL3010_R01PastFilter']) => set((state) => {
		return {
			...state,
			SAL3010_R01PastFilter: filter
		}
	}),

	// ====== 매출 리스트 및 선택/편집 ======
	SAL3010_R01List: [],
	setSAL3010_R01List: (dataList: SAL3010_R01HeaderDto[]) => set((state) => {
		return {
			...state,
			SAL3010_R01List: dataList
		}
	}),

	editSAL3010_R01: defaultSAL3010_R01HeaderDto,
	setEditSAL3010_R01: (editSale: SAL3010_R01HeaderDto | null) => set((state) => {
		return {
			...state,
			editSAL3010_R01: editSale
		}
	}),

	selectedSAL3010_R01: undefined,
	
	setSelectedSAL3010_R01: (data: SAL3010_R01HeaderDto | undefined) => set((state) => {
		return { 
			selectedSAL3010_R01: data,
			selectedSAL3010_R01DetailList: [], deletedSAL3010_R01DetailList: [],
			detailFetchTrigger: true,
			detailScrollTop: null,
		};
	}),
	initSelectedSAL3010_R01: () => set({ selectedSAL3010_R01: undefined, SAL3010_R01DetailList: [], detailFetchTrigger: false }),

	// ====== 매출 상세(디테일) 데이터 ======
	SAL3010_R01DetailList: [],
	setSAL3010_R01DetailList: (data: SAL3010_R01DetailDto[]) => set((state) => {
		let newList: SAL3010_R01DetailDto[] = [];
		let valueAndOrderIndex = 1;
		data.forEach((item, index) => {
			// console.log(index + '번째 행의 item.Index 정보: ' 
			// 	+ ' valueIndex : ' + item.valueIndex 
			// 	+ ' valueAndOrderIndex : ' + valueAndOrderIndex
			// 	+ ' orderIndex : ' + item.orderIndex 
			// 	+ ' orderIndexSeq : ' + item.orderIndexSeq);
			newList.push({ 
				//...defaultSAL3010_R01DetailDto,
				...item,
				valueIndex: item.valueIndex > 0 ? item.valueIndex : valueAndOrderIndex,
				orderIndex: item.orderIndex > -1 ? item.orderIndex : valueAndOrderIndex,
				orderIndexSeq: item.orderIndexSeq > 0 ? item.orderIndexSeq : 0
			});
			valueAndOrderIndex++;
		});
		return {
			...state,
			SAL3010_R01DetailList: newList
		}
	}),
	insertSAL3010_R01DetailList: (data: SAL3010_R01DetailDto[], index?: number) => set((state) => {
		let newSAL3010_R01DetailList = [...state.SAL3010_R01DetailList];

		let targetRowData = newSAL3010_R01DetailList.find(item => item.valueIndex === index);
		let targetOrderIndex = targetRowData?.orderIndex || 0;
		// 데이터에 orderIndex가 있으면 그것을 사용하고, 없으면 1 (index 파라미터는 배열 위치로만 사용)		

		const newOrderIndexSeq = (targetRowData?.orderIndexSeq || 0) + 1;
		// console.log('targetOrderIndex : ', targetOrderIndex);
		// console.log('newOrderIndexSeq : ', newOrderIndexSeq);
		let maxValueIndex = Math.max(0, ...newSAL3010_R01DetailList.map(item => item.valueIndex || 0)) + 1;

		// newSYS4100_R01List에서 targetOrderIndex인 행들을 빼내서 newOrderIndexSeq 기준으로 다시 정렬
		// newOrderIndexSeq 보다 orderIndexSeq가 작은 행들은 유지. 
		// newOrderIndexSeq 보다 orderIndexSeq가 큰 행들은 기존 orderIndexSeq 값에 1을 더해서 저장.
		const targetRows = newSAL3010_R01DetailList.filter(item => item.orderIndex === targetOrderIndex);
		targetRows.forEach(item => {
			if(item.orderIndexSeq < newOrderIndexSeq) {
				item.orderIndexSeq = item.orderIndexSeq;
			} else if(item.orderIndexSeq >= newOrderIndexSeq) {
				item.orderIndexSeq = item.orderIndexSeq + 1;
			}
		});

		// targetRows를 newSYS4100_R01List에 대체
		newSAL3010_R01DetailList = newSAL3010_R01DetailList.filter(item => item.orderIndex !== targetOrderIndex);
		newSAL3010_R01DetailList.push(...targetRows);
		
		//새 행을 생성해서 newOrderIndexSeq 값의 행을 저장
		const newData = data.map(item => ({ ...defaultSAL3010_R01DetailDto, ...item, 
			valueIndex: maxValueIndex++,
			orderIndex: targetOrderIndex,
			orderIndexSeq: newOrderIndexSeq
		}));
		if (index !== undefined) {
			newSAL3010_R01DetailList.splice(index, 0, ...newData);
		} else {
			newSAL3010_R01DetailList.push(...newData);
		}

		return {
			...state,
			SAL3010_R01DetailList: newSAL3010_R01DetailList
		}
	}),
	removeSAL3010_R01DetailList: (index: number) => set((state) => {
		const newSAL3010_R01DetailList = [...state.SAL3010_R01DetailList].filter((item) => item.valueIndex !== index);
		return {
			...state,
			SAL3010_R01DetailList: newSAL3010_R01DetailList
		}
	}),
	updateSAL3010_R01DetailList: (valueIndex: number, data: SAL3010_R01DetailDto) => set((state) => {
		const _SAL3010_R01DetailList = state.SAL3010_R01DetailList.map(item =>
			item.valueIndex === valueIndex ? data : item
		);
		return {
			...state,
			SAL3010_R01DetailList: _SAL3010_R01DetailList
		}
	}),
	
	// ====== 상세(디테일) 행 선택/삭제 관리 ======
	deletedSAL3010_R01DetailList: [],
	setDeletedSAL3010_R01DetailList: (idList: string[]) => set((state) => {
		return {
			...state,
			deletedSAL3010_R01DetailList: idList
		}
	}),
	addDeletedSAL3010_R01DetailList: (idList: string[]) => set((state) => {
		const _deletedDetailList = [...state.deletedSAL3010_R01DetailList];

		for(const valueIndex of idList) {
			const isInserted = state.SAL3010_R01DetailList.find(item => item.valueIndex === Number(valueIndex) && item.inserted);
			const isModified = state.SAL3010_R01DetailList.find(item => item.valueIndex === Number(valueIndex) && item.isModified);
			if(!isInserted && !isModified) {
				_deletedDetailList.push(valueIndex);
			}
		}
		
		return {
			...state,
			deletedSAL3010_R01DetailList: _deletedDetailList
		}
	}),
	removeDeletedSAL3010_R01DetailList: (idList?: string[]) => set((state) => ({
		...state,
		deletedSAL3010_R01DetailList: [...state.deletedSAL3010_R01DetailList].filter(value => idList ? !idList.includes(value) : false)
	})),

	selectedSAL3010_R01DetailList: [],
	setSelectedSAL3010_R01DetailList: (idList: string[]) => set((state) => {
		return {
			...state,
			selectedSAL3010_R01DetailList: idList
		}
	}),
	addSelectedSAL3010_R01DetailList: (idList: string[]) => set((state) => {
		const _selectedSAL3010_R01DetailList = [...state.selectedSAL3010_R01DetailList];
		if(idList.length > 0) {
			_selectedSAL3010_R01DetailList.push(...idList);
		}
		return {
			...state,
			selectedSAL3010_R01DetailList: _selectedSAL3010_R01DetailList
		}
	}),
	removeSelectedSAL3010_R01DetailList: (idList?: string[]) => set((state) => ({
		...state,
		selectedSAL3010_R01DetailList: [...state.selectedSAL3010_R01DetailList].filter(value => idList ? !idList.includes(value) : false)
	})),
	initSelectedSAL3010_R01DetailList: () => set({ selectedSAL3010_R01DetailList: [] }),

	originalSAL3010_R01DetailList: [],
	setOriginalSAL3010_R01DetailList: (data: SAL3010_R01DetailDto[]) => set((state) => {
		let newList: SAL3010_R01DetailDto[] = [];
		let valueAndOrderIndex = 1;
		data.forEach((item, index) => {
			newList.push({ 
				...defaultSAL3010_R01DetailDto,
				...item,
				valueIndex: valueAndOrderIndex,
				orderIndex: valueAndOrderIndex,
				orderIndexSeq: valueAndOrderIndex
			});
			valueAndOrderIndex++;
		});
		return {
			...state,
			originalSAL3010_R01DetailList: newList
		}
	}),

	// ====== 컬럼 상태(그리드) ======
	columnState: null,
	setColumnState: (state: ColumnState[] | null) => set({ columnState: state }),
	detailColumnState: null,
	setDetailColumnState: (state: ColumnState[] | null) => set({ detailColumnState: state }),

	allCount: 0,					setAllCount: (allCount: number) => set({ allCount }),
	detailFetchTrigger: false,		setDetailFetchTrigger: (trigger: boolean) => set({ detailFetchTrigger: trigger }),
	detailCreateTrigger: false,		setDetailCreateTrigger: (trigger: boolean) => set({ detailCreateTrigger: trigger }),

	scrollTop: null,
	setScrollTop: (top: number | null) => set({ scrollTop: top }),
	detailScrollTop: null,
	setDetailScrollTop: (top: number | null) => set({ detailScrollTop: top }),
						

	// ====== 초기화 ======
	initData: () => set((state) => ({
		...state,
		SAL3010_R01Filter: defaultSAL3010_R01Filter,
		SAL3010_R01PastFilter: defaultSAL3010_R01Filter,
		SAL3010_R01List: [],
		selectedSAL3010_R01: undefined,
		SAL3010_R01DetailList: [],
		deletedSAL3010_R01DetailList: [],
		selectedSAL3010_R01DetailList: [],
		editSAL3010_R01: defaultSAL3010_R01HeaderDto,
		allCount: 0,
		detailFetchTrigger: false,
		detailCreateTrigger: false,
		columnState: null,
		detailColumnState: null,
		scrollTop: null,
		detailScrollTop: null,
	})),

	
}));
